import React from "react";
import { TEAM_NAMES, TEAM_COLORS } from "../../../core/constants";
import "../ResultScreen.css";

interface ResultHeaderProps {
  winningTeam: number | null;
  isSinglePlayer: boolean;
}

const ResultHeader: React.FC<ResultHeaderProps> = ({ winningTeam, isSinglePlayer }) => {
  return (
    <div className="result-screen-header">
      <h1 className="result-screen-title">Game Results</h1>
      {winningTeam !== null && !isSinglePlayer && (
        <div className="result-screen-winner">
          <span
            className="result-screen-winner-team"
            style={{ color: TEAM_COLORS[winningTeam] }}
          >
            {TEAM_NAMES[winningTeam]} Wins!
          </span>
        </div>
      )}
    </div>
  );
};

export default ResultHeader;

